import { useCallback } from 'react';
import { PreferenesDTO } from 'business/models/Models';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';

type SavePreferencesParams = {
  updatedProperties: any[];
  preferenceType: string;
  fetchUserPrefs?: () => void;
  onSuccess?: () => void;
  onFinally?: () => void;
};

export const useSavePreferences = () => {
  const savePreferences = useCallback(async (params: SavePreferencesParams) => {
    const { updatedProperties, preferenceType, onSuccess, onFinally } = params;

    try {
      const service = new GlobalPreferencesService();
      const preferences = new PreferenesDTO();
      preferences.baseProperties = updatedProperties;
      preferences.preferenceType = preferenceType === 'global' ? 'global' : 'user';
      await service.setAllProperties(preferences);
      onSuccess && onSuccess();
    } finally {
      onFinally && onFinally();
    }
  }, []);

  return { savePreferences };
};
